export default __webpack_public_path__ + "static/media/199.574d4c53.jpg";